var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteForDemo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13086 1H14.8685V9.00294H3.13086V1Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13086 4.20117H14.8685",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00016 16.8719C10.0315 16.8719 10.8675 16.0359 10.8675 15.0046C10.8675 13.9732 10.0315 13.1372 9.00016 13.1372C7.96885 13.1372 7.13281 13.9732 7.13281 15.0046C7.13281 16.0359 7.96885 16.8719 9.00016 16.8719Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 19.0059C11.1419 18.0207 10.1162 17.4053 8.99968 17.4053C7.88312 17.4053 6.85747 18.0207 6.33203 19.0059",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4201 14.8719C15.4514 14.8719 16.2874 14.0359 16.2874 13.0046C16.2874 11.9732 15.4514 11.1372 14.4201 11.1372C13.3888 11.1372 12.5527 11.9732 12.5527 13.0046C12.5527 14.0359 13.3888 14.8719 14.4201 14.8719Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9994 16.7406C16.3743 15.8562 15.3404 15.353 14.2588 15.4067C13.1772 15.4605 12.1982 16.0639 11.6641 17.0059",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58024 14.8719C4.61155 14.8719 5.4476 14.0359 5.4476 13.0046C5.4476 11.9732 4.61155 11.1372 3.58024 11.1372C2.54893 11.1372 1.71289 11.9732 1.71289 13.0046C1.71289 14.0359 2.54893 14.8719 3.58024 14.8719Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.7406C1.62501 15.8562 2.65897 15.353 3.74058 15.4067C4.82219 15.4605 5.80112 16.0639 6.33529 17.0059",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteForDemo);
export default __webpack_public_path__ + "static/media/InviteForDemo.de40fefe16c99c0976bfaa9e150f1f6e.svg";
export { ForwardRef as ReactComponent };